import { StateToken } from '@ngxs/store';
import { IAuthState } from './auth.state';

export const AUTH_STATE_TOKEN = new StateToken<IAuthState>('auth');

// Kept so logout can purge any stale auth payload left in localStorage by the
// legacy IdentityServer4 flow; the auth state itself is no longer persisted.
export const AUTH_STATE_LOCAL_STORAGE_KEYS = [AUTH_STATE_TOKEN.getName()];
